import React, { PureComponent, ReactNode } from 'react';
import { DeviceState, GetDevices } from '../../containers/rtc/DeviceManagerContext';
import { UserAction } from '../../services/rtc/DeviceManager';
import BrowserSettingsChangeHelp from './BrowserSettingsChangeHelp';
import ConnectDevice from './ConnectDevice';
import DeviceCheck from './DeviceCheck';
import InitialSetup from './InitialSetup';
import MakeDeviceReadable from './MakeDeviceReadable';
import { IDeviceManagerState } from 'app/services/rtc/DeviceManager/DeviceManagerState';

interface IDeviceSetupProps {
  readonly devices: IDeviceManagerState;
}

class DeviceSetup extends PureComponent<IDeviceSetupProps> {
  public render() {
    const {
      props: { devices: { audio, video } },
    } = this;

    if (audio.userAction) {
      // Audio could be last step if camera is already configured.
      return this.renderDeviceSetup(audio, !video.isInitial && video.userAction === UserAction.None);
    }

    if (video.userAction) {
      return this.renderDeviceSetup(video, true);
    }

    return null;
  }

  /**
   * @params lastDevice - Is this the last device to be set up?
   */
  private renderDeviceSetup(device: DeviceState, lastDevice: boolean): ReactNode {
    switch (device.userAction) {
      case UserAction.AskPermission:
        return <InitialSetup type={device.type} />;
      case UserAction.InspectDeviceSettings:
        return <DeviceCheck last={lastDevice} type={device.type} />;
      case UserAction.ConnectDevice:
        return <ConnectDevice type={device.type} />;
      case UserAction.MakeDeviceReadable:
        return <MakeDeviceReadable type={device.type} />;
      case UserAction.ChangeBrowserSettings:
      case UserAction.ChangeBrowserSettingsAndRetry:
      case UserAction.ChangeBrowserSettingsAndReload:
        return <BrowserSettingsChangeHelp type={device.type} />;
      default:
        return null;
    }
  }
}

const DeviceSetupDependencies = () =>
  <GetDevices>{(devices) =>
    devices && !devices.dismissed && <DeviceSetup devices={devices} />
  }</GetDevices>;

export default DeviceSetupDependencies;
